import { render, staticRenderFns } from "./AgentWithdraw.vue?vue&type=template&id=00cdf372&scoped=true"
import script from "./AgentWithdraw.vue?vue&type=script&lang=js"
export * from "./AgentWithdraw.vue?vue&type=script&lang=js"
import style0 from "./AgentWithdraw.vue?vue&type=style&index=0&id=00cdf372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cdf372",
  null
  
)

export default component.exports